<template>
    <div class="wrapper">
        <app-header></app-header>
        <hr>
        <div class="container mb-5">

            <ul class="nav nav-pills">
                <li class="nav-item">
                    <a class="nav-link active" data-toggle="pill" href="#events">Events</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-toggle="pill" href="#notices">Notices</a>
                </li>
            </ul>

            
            <div class="tab-content">

                <!-- event tabs -->
                <div id="events" class="tab-pane active">

                   <app-events></app-events>

                </div>
             
               <!-- notice tab start here -->
                <div id="notices" class="tab-pane fade">
                  
                  <app-notices></app-notices>
                   
                </div>
               
            </div>

        </div>

        <!-- <div class="events">
            <div class="events_title">
                <span class="events_title-big"><span>HOSA</span> EVENTS</span>
                <div class="events_title-block"></div>
                <span class="events_title-small">Please see our upcoming events below</span>
            </div>
        </div>
        <app-event-table v-bind:events="events"></app-event-table>
        <app-events v-on:dateSelect="setDate" v-bind:dateF="filters.dateF" v-bind:dateT="filters.dateT"></app-events> -->
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Header from '@/components/layout/NewHeader';
    import Footer from '@/components/layout/NewFooter';
    import Events from './Event';
    import Notices from './Notices';
    // import Events from '../Main/Events/Events';
    // import EventTable from './EventTable'
    // import EventServices from "../../services/EventServices";
    export default {
        components: {
            'app-header': Header,
            'app-footer': Footer,
            'app-events': Events,
            'app-notices': Notices,
        },
        data(){
            return {  
            }
        },
    
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        width:100%;
    }
    .events{
        display: flex;
        margin-top: 110px;
        margin-right: auto;
        margin-left: auto;
        &_title {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 64px;

            &-big {
                color: #38383a;
                font-family: "Optimal C";
                font-size: 30px;
                font-weight: 400;
                text-transform: uppercase;
                letter-spacing: 0.07px;
                margin-bottom: 26px;
                span {
                    color: #1a924a;
                }
            }
            &-small {
                margin-top: 45px;
                width: 739px;
                height: 14px;
                color: #38383a;
                font-family: "Open Sans";
                font-size: 14px;
                font-weight: 400;
                line-height: 28px;
                /* Text style for "We regular" */
                letter-spacing: 0.7px;
                margin-bottom: 75px;
            }

            &-block {
                width: 63px;
                height: 3px;
                background-color: #2a9854
            }
        }
    }

</style>
